'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class;

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components2 = require('components');

var _reduxAsyncConnect = require('redux-async-connect');

var _basket = require('redux/actions/basket');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Basket: {
        displayName: 'Basket'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Basket/Basket.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Basket = _wrapComponent('Basket')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        var products = getState().basket.items;
        if (products) {
            return dispatch((0, _extends3.default)({}, (0, _basket.getActualPrices)(products)));
        }
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang
    };
}), _dec(_class = _dec2(_class = function (_Component) {
    (0, _inherits3.default)(Basket, _Component);

    function Basket() {
        (0, _classCallCheck3.default)(this, Basket);
        return (0, _possibleConstructorReturn3.default)(this, (Basket.__proto__ || (0, _getPrototypeOf2.default)(Basket)).apply(this, arguments));
    }

    (0, _createClass3.default)(Basket, [{
        key: 'render',
        value: function render() {
            var helmetTitle = this.props.lang['store.helmet.cart'];

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
                _react3.default.createElement(_components2.Basket, { before: _react3.default.createElement(_components2.OrderSteps, { step: '1' }) })
            );
        }
    }]);
    return Basket;
}(_react2.Component)) || _class) || _class));

exports.default = Basket;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Basket/Basket.jsx
// module id = 1800
// module chunks = 0